import { required } from 'utils/validation'

export default function(values) {
  return {
    username: required(values.username),
    password: required(values.password)
  }
}
